<section class="table-toolbar" [attr.aria-label]="title">
  <div class="table-toolbar-heading">
    <div>
      <h5 class="mb-1 fw-semibold"><i [class]="icon + ' me-2 text-primary'" aria-hidden="true"></i>{{ title }}</h5>
      <small class="text-muted" *ngIf="description">{{ description }}</small>
    </div>
    <div class="table-toolbar-actions"><ng-content select="[tableActions]"></ng-content></div>
  </div>

  <div class="table-toolbar-controls">
  <div class="table-toolbar-search" *ngIf="searchable">
    <label [for]="searchId" class="form-label mb-1 small fw-semibold text-muted">Buscar</label>
    <div class="table-toolbar-search-row">
      <div class="table-search-field"><input #searchInput [id]="searchId" type="search" class="form-control"
        [placeholder]="placeholder" [value]="searchValue" (input)="search(searchInput.value)" (keydown.enter)="$event.preventDefault(); search(searchInput.value)">
      <button type="button" class="table-search-submit" (click)="search(searchInput.value)" aria-label="Buscar en la tabla" title="Buscar"><i class="fas fa-search" aria-hidden="true"></i></button></div>
      <button type="button" class="btn btn-outline-danger btn-sm" (click)="clearSearch()"
        title="Limpia búsqueda y filtros aplicados.">
        <i class="fas fa-eraser me-1" aria-hidden="true"></i>Limpiar
      </button>
      <button *ngIf="refreshable" type="button" class="btn btn-outline-secondary btn-sm"
        (click)="refresh.emit()" [disabled]="refreshing" title="Actualizar tabla">
        <i class="fas fa-sync-alt me-1" aria-hidden="true"></i>Actualizar
      </button>
    </div>
  </div>

  <div *ngIf="exportable" class="table-toolbar-exports" role="group" aria-label="Exportar tabla" [attr.aria-busy]="loading">
    <span *ngIf="loading" class="text-muted small" role="status"><i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>Preparando archivo...</span>
    <button type="button" class="btn btn-outline-danger btn-sm" (click)="pdf.emit()" [disabled]="loading" title="Exportar tabla en PDF">
      <i class="far fa-file-pdf me-2" aria-hidden="true"></i>PDF
    </button>
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="csv.emit()" [disabled]="loading" title="Exportar tabla en CSV">
      <i class="fas fa-file-csv me-2" aria-hidden="true"></i>CSV
    </button>
    <button type="button" class="btn btn-outline-success btn-sm" (click)="excel.emit()" [disabled]="loading" title="Exportar tabla en Excel">
      <i class="far fa-file-excel me-2" aria-hidden="true"></i>Excel
    </button>
  </div>
  </div>
  <div class="table-toolbar-filters"><ng-content></ng-content></div>
</section>
